import "core-js/modules/es.string.replace";
import React from 'react';
import { useHistory } from 'react-router-dom';

function useRedirect() {
  var history = useHistory();
  var setRedirect = React.useCallback(function (location) {
    var routeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var push = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var action = push ? history.push : history.replace;
    action(location, routeState);
  }, [history.push, history.replace]);
  return setRedirect;
}

export default useRedirect;